import React from 'react';

import { Flex, Inline } from '@atlaskit/primitives/compiled';

import { ErrorBoundary } from '../../../controllers/error-boundary';
import { useBootstrapLoading } from '../../../controllers/store';

import { LoadingFilters } from './loading-filters';
import ProductFilters, { StackedProductFilters } from './product-filters';

export const Filters = (): React.JSX.Element => {
	const [bootstrapLoading] = useBootstrapLoading();

	if (bootstrapLoading) {
		return <LoadingFilters />;
	}

	return (
		<Flex direction="column" gap="space.200">
			<Inline space="space.100">
				<ProductFilters />
			</Inline>
		</Flex>
	);
};

const FiltersWithErrorBoundary = (): React.JSX.Element => {
	return (
		<ErrorBoundary fallback={null}>
			<Filters />
		</ErrorBoundary>
	);
};

export default FiltersWithErrorBoundary;

export const StackedFilters = ({
	filtersToHide,
}: {
	filtersToHide: string[];
}): React.JSX.Element => {
	const [bootstrapLoading] = useBootstrapLoading();

	if (bootstrapLoading) {
		return <LoadingFilters />;
	}

	return <StackedProductFilters filtersToHide={filtersToHide} />;
};
